import Vue from 'vue';
import Vuex from 'vuex';
// import createLogger from 'vuex/dist/logger';
import axios from 'axios';
import * as type from './type';
import storage from 'baimahu/storage';
const { NODE_ENV, VUE_APP_FCAPI } = process.env;
const debug = NODE_ENV !== 'production';

console.debug(process.env);

const API = {
  fetch_basis: `${VUE_APP_FCAPI}/shang/setting/profile`,
  permission: `${VUE_APP_FCAPI}/shang/setting/auth`,
};

function getBasis(data?: Business.Basis): Business.Basis {
  return (
    data || {
      mobile: '',
      logo: '',
      role_name: '',
      wxapp_name: '',
      guide_to_wx_qrcode: '',
      guide_to_wx_id: '',
      specily_ware_name: '',
    }
  );
}

Vue.use(Vuex);

export default new Vuex.Store({
  strict: debug,
  // plugins: debug ? [createLogger()] : [],

  state: {
    is_logged_on: !!storage.getItem('profile'),
    basis: getBasis(),
    permission: [],
    menu: [],
  },

  mutations: {
    [type.MUTATION_LOG_ON_OUT](state, status: boolean) {
      if (!status) {
        storage.removeItem('profile');
      }
      state.is_logged_on = status;
    },
    [type.MUTATION_SET_BASIS](state, payload: Business.Basis) {
      state.basis = getBasis(payload);
    },
    [type.MUTATION_SET_PERMISSION](state, payload) {
      state.permission = payload;
    },
    [type.MUTATION_SET_MENU](state, payload: any) {
      state.menu = payload;
    },
  },

  actions: {
    async [type.ACTION_RELOAD_BASIS]({ commit }) {
      try {
        const profile = storage.getItem('profile') || {};
        if (!profile) {
          throw new Error('no profile');
        }
        const _data = ((await axios.get(`${API.fetch_basis}/${profile.merchant_id}`)) || {}).data || {};
        if (_data.status !== 200) {
          throw new Error(_data.message);
        }
        const data: Business.Basis = _data.data;
        commit(type.MUTATION_SET_BASIS, data);
      } catch (e) {
        commit(type.MUTATION_LOG_ON_OUT, false);
      }
    },
    async [type.ACTION_GET_PERMISSION]({ commit }) {
      const _data = ((await axios.get(`${API.permission}`)) || {}).data || {};
      if (_data.status !== 200) {
        throw new Error(_data.message);
      }
      const data: any = _data.data;
      commit(type.MUTATION_SET_PERMISSION, data);
    },
  },
});
